import { render, staticRenderFns } from "./QrcodeDisplayCertificate.vue?vue&type=template&id=27c50e76&scoped=true&"
import script from "./QrcodeDisplayCertificate.vue?vue&type=script&lang=js&"
export * from "./QrcodeDisplayCertificate.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeDisplayCertificate.vue?vue&type=style&index=0&id=27c50e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c50e76",
  null
  
)

export default component.exports